import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ListColorPipe } from './list-color.pipe';
import { SearchPipe } from './search.pipe';
import { DateDiffPipe } from './date-diff.pipe';
import { CustomDecimalPipe } from './custom-decimal.pipe';
import { CitySortPipe } from './city-sort.pipe';
import { CityUniqueLabelPipe } from './city-unique-label.pipe';
import { CountrySortPipe } from './country-sort.pipe';
import { AlphabeticSortPipe } from './alphabetic-sort.pipe';
import { TruncatePipe } from './string-truncate.pipe';

@NgModule({
  declarations: [
    SearchPipe,
    DateDiffPipe,
    ListColorPipe,
    CustomDecimalPipe,
    CitySortPipe,
    CityUniqueLabelPipe,
    CountrySortPipe,
    AlphabeticSortPipe,
    TruncatePipe,
  ],
  imports: [CommonModule],
  exports: [CustomDecimalPipe, SearchPipe, DateDiffPipe, ListColorPipe, CitySortPipe, CityUniqueLabelPipe, CountrySortPipe, AlphabeticSortPipe, TruncatePipe],
  providers: [DecimalPipe, CityUniqueLabelPipe, CountrySortPipe, AlphabeticSortPipe],
})
export class PipesModule {}
